import React from 'react';
import Grid from '@material-ui/core/Grid'
import GPMS from '../../../assets/home/caixa.svg';
import GPESSOA from '../../../assets/home/pessoa.svg';
import NF from '../../../assets/home/nota.svg';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    controlaBotao: {
        padding: 10,
        height: 140
    },
    legenda: {
        fontSize: '0.9rem',
        textAlign: 'center'
    },
    controlaLegenda: {
        height: '30%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    icone: {
        height: '70%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    controlaPaddingUm: {
        padding: 4
    },
    controlaIcone: {
        borderRadius: "50%",
        width: 80,
        height: 80
    }
}))

function BotoesHome({ history }) {

    function vaiListagemPessoa() {
        history.push('/pessoa')
    }

    function vaiListagemProduto() {
        history.push('/produto')
    }

    function vaiListagemNfe() {
        history.push('/nfe')
    }

    const classes = useStyles();

    return (
        <Grid container align="center" justify="center" id="home-botoes">
            <Grid item xs={4} className={classes.controlaPaddingUm} id="home-cadastro-produto">
                <Paper
                    onClick={vaiListagemProduto}
                    className={classes.controlaBotao}
                >
                    <div className={classes.icone}>
                        <img src={GPMS}
                            alt="Cadastro de Produto"
                            className={classes.controlaIcone}
                        />
                    </div>
                    <div className={classes.controlaLegenda}>
                        <Typography
                            variant="h5"
                            component="h5"
                            gutterBottom
                            align="center"
                            color="primary"
                            className={classes.legenda}
                        >
                            Produtos
                        </Typography>
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={4} className={classes.controlaPaddingUm} id="home-cadastro-pessoa">
                <Paper
                    onClick={vaiListagemPessoa}
                    className={classes.controlaBotao}
                >
                    <div className={classes.icone}>
                        <img src={GPESSOA}
                            alt="Cadastro de Pessoa"
                            className={classes.controlaIcone}
                        />
                    </div>
                    <div className={classes.controlaLegenda}>
                        <Typography
                            variant="h5"
                            component="h5"
                            gutterBottom
                            align="center"
                            color="primary"
                            className={classes.legenda}
                        >
                            Pessoas
                        </Typography>
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={4} className={classes.controlaPaddingUm} id="home-cadastro-nota-fiscal">
                <Paper
                    onClick={vaiListagemNfe}
                    className={classes.controlaBotao}
                >
                    <div className={classes.icone}>
                        <img src={NF}
                            alt="Nota Fiscal"
                            className={classes.controlaIcone}
                        />
                    </div>
                    <div className={classes.controlaLegenda}>
                        <Typography
                            variant="h5"
                            component="h5"
                            gutterBottom
                            align="center"
                            color="primary"
                            className={classes.legenda}
                        >
                            Nota Fiscal Eletrônica
                        </Typography>
                    </div>
                </Paper>
            </Grid>
        </Grid>
    )
}

export default withRouter(BotoesHome);